<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="yearSearch" :placeholder="$t('placeholder.Year2')">
            <el-option
                v-for="item in optionsYear"
                :key="item.id"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchSystem(yearSearch)">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
          :data="rateSystemData"
          :span-method="objectSpanMethod"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%;">
        <el-table-column
            prop="oneIndex"
            :label="$t('label.oneIndex')"
            width="180">
        </el-table-column>
        <el-table-column
            prop="oneIndexValue"
            :label="$t('label.oneIndexValue')">
        </el-table-column>
        <el-table-column
            prop="twoIndex"
            :label="$t('label.twoIndex')">
        </el-table-column>
        <el-table-column
            prop="twoIndexValue"
            :label="$t('label.twoIndexValue')">
        </el-table-column>

        <template slot="empty">
          <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "rateSystemSearch",
  data() {
    return {
      optionsYear: [],
      rateSystemData:[],
      yearSearch:'',
      needMergeArr: ['oneIndex'],// 有合并项的列
      rowMergeArrs: {}
    }
  },
  methods: {
    objectSpanMethod({column,rowIndex}) {
      if (column.property === 'oneIndex') return this.mergeAction('oneIndex', rowIndex, column);
      if (column.property === 'oneIndexValue') return this.mergeAction('oneIndex', rowIndex, column);
    },
    mergeAction(val, rowIndex) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },
    rowMergeHandle(arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false;
      if (!Array.isArray(data) && !data.length) return false;
      let needMerge = {};
      arr.forEach(i => {  // i 为 'oneIndex'
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0
        };
        data.forEach((item, index) => {
          if (index === 0) {
            needMerge[i].rowArr.push(1);
            needMerge[i].rowMergeNum = 0;
          } else {
            if (item[i] === data[index - 1][i]) {
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
              needMerge[i].rowArr.push(0);
            }
            else {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = index;
            }
          }
        });
      });
      return needMerge;
    },
    searchSystem(yearSearch) {
      if(yearSearch===''){
        alert("请选择查询年份！")
      }
      else{
        var that=this
        that.rateSystemData=[]
        request.get('/dataquery/evaSys?year=' + yearSearch).then(result => {
          var List = []
          var ListChild = []
          var temp = []
          var dict = {}
          var oneIndex,oneIndexValue
          // if(Object.keys(result.data).length===1){
          //   List=result.data[0].children
          // }
          // else{
          //   List.push(result.data[0])
          //   List.push(result.data[1])
          // }
          List=result.data[0].children
          for(let i=0;i<List.length;i++){
            if(this.$i18n.locale==='cn'){
              oneIndex = List[i].name_cn
            }
            else{
              oneIndex = List[i].name_en
            }
            oneIndexValue = List[i].weight
            ListChild = List[i].children
            for(let j=0;j<ListChild.length;j++){
              dict={}
              var value=oneIndexValue*100
              dict.oneIndex=oneIndex
              dict.oneIndexValue=parseFloat(value).toFixed(0)
              if(this.$i18n.locale==='cn'){
                dict.twoIndex = ListChild[j].name_cn
              }
              else{
                dict.twoIndex = ListChild[j].name_en
              }
              dict.twoIndexValue = ListChild[j].weight
              temp.push(dict)
            }
          }
          that.rateSystemData = temp
          this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.rateSystemData);
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>